/**
 * `/v1/products/{id}/variants` — AI 22 consumer product variants.
 *
 * **The `cpv` rule was a fourth hand-written copy of GS1 charset X**, and c33's pattern
 * move missed it. `variants.ts` held `const CPV = /^[!%-?A-Z_a-z"]{1,20}$/` under a
 * comment saying it was *"deliberately the same expression as the SQL rather than a
 * looser one"* — correct, unchecked, and exactly the claim that turned out to need a test
 * rather than a sentence. It now comes from {@link CHARSET_X}, which
 * `constraints.test.ts` holds against `product_variants_cpv_check` itself.
 *
 * That miss is worth naming rather than quietly fixing: c33's exhaustiveness assertion
 * checks the **database** has no regex CHECK the shared map does not name. It cannot see
 * a **source file** re-spelling a pattern, which is the direction this survived in.
 */
import { z } from "zod";
import { CHARSET_X } from "./patterns.js";
/**
 * The message the route refused with, carried across verbatim.
 *
 * Not a paraphrase and not zod's default. These strings are the wire (c29's rule), and a
 * migration that improves the copy is a migration that moved it.
 */
const CPV_MESSAGE = "cpv must be 1–20 characters of GS1 charset X.";
export const createVariantSchema = z
    .object({
    cpv: z.string(CPV_MESSAGE).regex(CHARSET_X, CPV_MESSAGE),
    /**
     * The localized variant name. Not flattened here — see `products.ts` on why picking a
     * language is the screen's decision and not the schema's.
     */
    name: z.record(z.string(), z.string()).optional(),
})
    .describe("POST /v1/products/{id}/variants");
//# sourceMappingURL=variants.js.map